import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, DEFINITION_KINDS, define } from '../types.js';

/**
 * Last shuttle move flag.
 *
 * @remarks
 * System-managed flag set during shuttle workflow assignment. When true, indicates
 * this is the last move in a shuttle sequence, triggering chase vehicle status
 * updates to 'returned'.
 */
export const schema = z.boolean().optional();

export type LastShuttleMove = z.infer<typeof schema>;

export const definition = define({
  key: 'lastShuttleMove',
  schema,
  label: 'Last Shuttle Move',
  description:
    'System flag marking this as the last move in a shuttle sequence. Triggers chase vehicle status to "returned". Set by shuttle planning, not user-configurable.',
  kind: DEFINITION_KINDS.OUTPUT,
  category: CATEGORIES.OPERATIONAL_STATE.key,
  writableAtLevels: [LEVELS.MOVE],
  readableByRoles: [ROLES.ADMIN],
});
